import React, {useState, useEffect} from "react";
import SubBanner from "../../../components/SubBanner";
import bannerImg from "../../../assets/img/resources_banner.png";
import dataImg from "../../../assets/img/data.png";
import { BOARD_LIST_URL } from "../../../utils/urls";
import instance from "../../../services/services";

function Data(){
   // 0: Notice, 1: FAQ, 2: 자료실, 3:Blog
  const [activeTab, setActiveTab] = useState(2);
  const [dataList, setDataList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  
  const itemsPerPage = 6; // 한 페이지당 보여줄 자료 수
  const totalPages = Math.ceil(totalCount / itemsPerPage);

  // 배너 탭
  const tabList = [
    { label : 'Notice', url : '/resources/notice'},
    { label : 'FAQ', url : '/resources/faq'},
    { label : '자료실', url : '/resources/data'},
    { label : 'Blog', url : '/resources/blog'},
  ]

  // 자료실 데이터 가져오기
  const fetchDataList = async (page = 1) => {
    try {
      const response = await instance.post(BOARD_LIST_URL, {
        boardid: "archive",
        offset: page.toString(),  
        limit: '6'
      });
      setDataList(response.data.data.data);
      setTotalCount(parseInt(response.data.data.cntRow));
    } catch (error) {
      console.error('자료실 데이터 가져오기 오류:', error);
    }
  };

  useEffect(() => {
    fetchDataList(currentPage);
  }, [currentPage]);

  // 페이지 변경 핸들러
  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  // 페이지네이션 번호 생성 (현재 페이지 기준으로 5개씩 표시)
  const getPageNumbers = () => {
    const pageNumbers = [];
    const startPage = Math.max(1, currentPage - 2);
    const endPage = Math.min(totalPages, startPage + 4);
    
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }
    return pageNumbers;
  };

  return(
    <div className="resources">
    {/* 배너 */}
      <SubBanner
        bgImg={bannerImg}
        title= {'자료실'}
        tabs={tabList.map((tab,idx) => ({
          label : tab.label,
          url : tab.url,
          active: activeTab === idx,
          onClick: () => setActiveTab(idx),
        }))}
        location={[
          { label: "Resources", url: "/resources" },
          { label: "자료실", url: "/resources/data", active: true }
        ]}
      />

      <section className="sub_section mt-[180px] md:mt-[210px] mb-[120px] mx-auto">

        {/* <ul className="data_container">
          {dataList.map((data,idx)=>(
            <li className="data_box" key={data.b_seq || idx}>
              <h3>{data?.subject}</h3>
              <figure className="rounded-[16px] overflow-hidden w-full">
                <img 
                  src={data?.fileList?.[0]?.file_path ? `https://admin-nhnace.kacelab.com${data.fileList[0].file_path}` : dataImg} 
                  alt={data?.fileList?.[0]?.file_name || 'img'} 
                  className="w-full h-full"
                  onClick={() => window.open(`https://admin-nhnace.kacelab.com${data.fileList[0].file_path}`, '_blank')}
                />
              </figure>
            </li>
          ))}
        </ul> */}
        
        <ul className="data_container">
          {dataList.map((data, idx) => {
            const filePath = data?.fileList?.[0]?.file_path; // 파일 경로
            const fileName = data?.fileList?.[0]?.file_name || 'img'; // 파일 이름 없으면 'img' 기본값
            const fileUrl = filePath ? `https://admin.nhnace.com${filePath}` : ''; // 전체 URL 생성
            const isPdf = fileName.toLowerCase().endsWith('.pdf'); // PDF 파일인지 확인

            return (
              <li className="data_box" key={data.b_seq || idx}>
                <h3>{data?.subject}</h3> {/* 자료 제목 */}
                <figure className="rounded-[16px] overflow-hidden w-full">
                  <img
                    src={isPdf || !filePath ? dataImg : fileUrl} // PDF나 파일 없음 -> 기본 이미지, 아니면 실제 이미지
                    alt={fileName} // 이미지 대체 텍스트
                    className="w-full h-full"
                    onClick={() => window.open(fileUrl, '_blank')} // 클릭 시 새 창에서 열기
                  />
                </figure>
              </li>
            );
          })}
        </ul>

        {/* Pagination */}
        <div className="flex justify-center items-center gap-[8px] mt-[50px] md:mt-[80px]">
          {/* 첫 페이지 */}
          <button 
            type="button" 
            className="page pg_first"
            onClick={() => handlePageChange(1)}
            disabled={currentPage === 1}
          ></button>
          
          {/* 이전 페이지 */}
          <button 
            type="button" 
            className="page pg_prev"
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          ></button>
          
          {/* 페이지 번호들 */}
          {getPageNumbers().map((num) => (
            <button
              key={num}
              className={`page_num w-[36px] h-[36px] rounded-[8px] ${
                num === currentPage ? "bg-[#F84343] text-white" : "text-[#999]"
              }`}
              onClick={() => handlePageChange(num)}
            >
              {num}
            </button>
          ))}
          
          {/* 다음 페이지 */}
          <button 
            type="button" 
            className="page pg_next"
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          ></button>
          
          {/* 마지막 페이지 */}
          <button 
            type="button" 
            className="page pg_last"
            onClick={() => handlePageChange(totalPages)}
            disabled={currentPage === totalPages}
          ></button>
        </div>
      </section> 

    </div>
  )
};

export default Data;